import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom'; // NEW IMPORT

function Contact() {
  const [searchParams] = useSearchParams(); // Hook to read URL parameters

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // NEW: Effect to check for bunny name in the URL on load
  useEffect(() => {
    const bunnyName = searchParams.get('bunny');
    const bunnyStatus = searchParams.get('status');

    if (bunnyName) {
      // Default to Reservation Inquiry
      let initialSubject = 'Reservation Inquiry';
      let initialMessage = `I am interested in reserving ${bunnyName}! Please let me know the next steps.`;

      // Change to Waitlist if the status matches
      if (bunnyStatus === 'waitlist') {
        initialSubject = 'Waitlist Inquiry';
        initialMessage = `I would like to join the waitlist for ${bunnyName}. Please let me know the next steps.`;
      }

      setFormData(prev => ({
        ...prev,
        subject: initialSubject,
        message: initialMessage
      }));
    }
  }, [searchParams]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const payload = {
      access_key: "cda67977-c6bd-4d38-a30d-dd2c84096b18",
      subject: `New Inquiry: ${formData.subject}`,
      from_name: formData.name,
      email: formData.email,
      message: formData.message
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (result.success) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '900px' }}>
      <Helmet>
        <title>Contact Us | Bunny Boutique 321</title>
        <meta name="description" content="Contact us with your questions, if you wish to reserve, or join our waitlist for one of our special bunnies." />
        <link rel="canonical" href="https://bunnyboutique321.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contact Us | Bunny Boutique 321" />
        <meta property="og:description" content="Contact us with your questions, if you wish to reserve, or join our waitlist for one of our special bunnies." />
        <meta property="og:url" content="https://bunnyboutique321.com/contact" />
        <meta property="og:image" content="https://bunnyboutique321.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us | Bunny Boutique 321" />
        <meta name="twitter:description" content="Contact us with your questions, if you wish to reserve, or join our waitlist for one of our special bunnies." />
        <meta name="twitter:image" content="https://bunnyboutique321.com/og-image.jpg" />
      </Helmet>
      <span className="eyebrow">Start a Conversation</span>
      <h1 style={{ marginBottom: '10px' }}>Get in Touch</h1>
      <p className="section-subtitle" style={{ marginTop: 0 }}>
        Have questions about an upcoming litter or our boutique products? Send us a message!
      </p>

      <div className="contact-layout">
        <div className="contact-info">
          <h3>Bunny Boutique 321</h3>
          <p><strong>Location:</strong> Melbourne, Florida</p>
          <p><strong>Email:</strong> <a href="mailto:sales@bunnyboutique321.com">sales@bunnyboutique321.com</a></p>
          <p><strong>Phone:</strong> <a href="tel:+13217209802">321-720-9802</a></p>
          <div style={{ marginTop: '30px' }}>
            <h4>Follow Our Fluff</h4>
            <p style={{ color: '#476085', fontSize: '0.95rem' }}>
              Check out our Instagram and Facebook for the latest litter announcements and nursery updates.
            </p>
          </div>
        </div>

        <div className="contact-form-container">
          {submitStatus === 'success' ? (
            <div className="success-message">
              <h3>Message Sent! 🐰</h3>
              <p>Thank you for reaching out. We will get back to you as soon as possible!</p>
              <button onClick={() => setSubmitStatus(null)} className="btn-secondary" style={{ marginTop: '15px' }}>Send Another Message</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label>Name</label>
                <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
              </div>

              <div className="form-group">
                <label>Subject</label>
                <select name="subject" value={formData.subject} onChange={handleInputChange} required>
                  <option value="" disabled>Select a topic...</option>
                  <option value="Reservation Inquiry">Reservation Inquiry</option>
                  <option value="Available Bunnies">Available Bunnies</option>
                  <option value="Waitlist Inquiry">Waitlist Inquiry</option>
                  <option value="Merchandise">Merchandise / Supplies</option>
                  <option value="General Question">General Question</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea name="message" rows="5" value={formData.message} onChange={handleInputChange} required></textarea>
              </div>

              <button type="submit" className="btn-primary" disabled={isSubmitting} style={{ width: '100%' }}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Contact;